import React from 'react'
import { RiRadioButtonLine } from 'react-icons/ri'
import { formatDate } from '../../utils/utilFuncs'

function AvailabilityStatus({ seller }) {
    return (
        <div className="sellerAvailabilityDiv">
            <h2 className="secondaryHeading">Availability</h2>
            <div className="horizontalLine"></div>
            <p className={`sellerAvailabilityStatus ${seller?.isAvailable ? "available" : "notAvailable"}`}>
                <RiRadioButtonLine /> {seller?.isAvailable ? "Available" : "Not Available"}
            </p>
            {<p className="infoText">{seller?.isAvailable ? "The seller is currently available for work." : `The seller is partially not available for work untill ${formatDate(seller?.unavailableEndDate)} and left a following message: "${seller?.unavailableMessage}"`}</p>}
        </div>
    )
}

export default AvailabilityStatus